// SEO Helper Functions

export interface ArticleSchema {
  title: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified?: string;
  author: string;
  category?: string;
  slug: string;
}

export const generateArticleSchema = (article: ArticleSchema) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.description,
    "image": article.image,
    "datePublished": article.datePublished,
    "dateModified": article.dateModified || article.datePublished,
    "author": {
      "@type": "Person",
      "name": article.author
    },
    "publisher": {
      "@type": "Organization",
      "name": "InvizHer",
      "logo": {
        "@type": "ImageObject",
        "url": "https://invizher.com/favicon.ico"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://invizher.com/posts/${article.slug}`
    }
  };
};

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export const generateBreadcrumbSchema = (items: BreadcrumbItem[]) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

export const generateOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "InvizHer",
    "url": "https://invizher.com",
    "logo": "https://invizher.com/favicon.ico",
    "description": "Programming tutorials, tech projects, and development resources",
    "sameAs": [
      "https://youtube.com/@invizher",
      "https://instagram.com/invizher",
      "https://t.me/invizher"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "invizher@gmail.com"
    }
  };
};

export const truncateDescription = (text: string, maxLength: number = 160): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3).trim() + '...';
};

export const cleanTextForMeta = (html: string): string => {
  // Remove HTML tags and clean up text
  const text = html.replace(/<[^>]*>/g, '');
  return text.replace(/\s+/g, ' ').trim();
};